<template>
  <div id="app">
    <div v-if="pc">
      <topcomponents v-if="is_display"></topcomponents>
      <main v-if="is_display"
        style="position: relative;background: #F6FAFF;min-width: 1200px;min-height: calc(100vh - 321px);">
        <router-view />
      </main>
      <main v-else>
        <router-view />
      </main>
      <webBottomcomponents v-if="is_display"></webBottomcomponents>
    </div>
    <!-- <div v-else-if="ipt === 'video_sk'">
      <main>
        <router-view />
      </main>
    </div> -->
    <div v-else>

    </div>
  </div>
</template>
<!-- <script type="text/javascript" src="http://pv.sohu.com/cityjson?ie=utf-8"></script> -->
<script>
  import topcomponents from "@/components/webTop/webTopMenu";
  import webBottomcomponents from "@/components/webBottom/webBottom";
  import 'tcplayer.js/dist/tcplayer.min.css';
  export default {
    name: "App",
    data() {
      return {
        list: [],
        ip: '',
        teid: 0,
        clickStarTime: '',
        clickEndTime: '',
        ipt: '',
        is_display: true,
        pc: true,
        isUserAgent: -1
      }
    },
    components: {
      topcomponents,
      webBottomcomponents,
      show: true
    },
    metaInfo: {
      meta: [
        {
          name: 'description',
          content: '医方教育网是中国新生代医学考试培训教育数字化产品专业服务商，依托国家互联网+教育和教育数字化两大教育创新战略，实现医学教育产品多样化。通过校企合作实现优势资源整合，开发了高质量的录播或直播形式的在线培训课程，并辅以海量题库打造全真模拟考试系统。以高水平教学质量和产品服务，赢得了用户的认可与尊重。'
        },
        {
          name: 'keywords',
          content: '执业/助理医师资格考试,护士资格考试,卫生专业技术资格考试辅导培训,医疗卫生健康人才网'
        }
      ]
    },
    methods: {
      ready() {
        //获取本地IP地址
        //js 引入
        //
        var cip = returnCitySN["cip"];
        //给vuedata对象里的字段赋值
        this.ip = cip
        // console.log(this.ip,cip)
      },
      //开始结束日期
      getmoed() {
        function addDateZero(num) {
          return num < 10 ? "0" + num : num;
        }
        var _date = new Date(); //获取今天日期
        let dz = new Date(_date);
        this.clickStarTime =
          dz.getFullYear() +
          "-" +
          addDateZero(dz.getMonth() + 1) +
          "-" +
          addDateZero(dz.getDate()) +
          " " +
          addDateZero(dz.getHours()) +
          ":" +
          addDateZero(dz.getMinutes()) +
          ":" +
          addDateZero(dz.getSeconds());
        let d = new Date(_date.setMinutes(_date.getMinutes() + 10));
        this.clickEndTime =
          d.getFullYear() +
          "-" +
          addDateZero(d.getMonth() + 1) +
          "-" +
          addDateZero(d.getDate()) +
          " " +
          addDateZero(d.getHours()) +
          ":" +
          addDateZero(d.getMinutes()) +
          ":" +
          addDateZero(d.getSeconds());
      },
      getmetime() {
        this.ready();
        this.getmoed();
        // console.log(this.clickStarTime,this.clickEndTime)
        var posturl =
          this.config.baseUrl.pro + "/PageView/apiAdd";
        axios
          .request({
            url: posturl,
            method: "post",
            changeOrigin: true,
            data: {
              clickType: this.teid,
              clickTypeName: 'indexPage',
              clickNum: 1,
              clickStarTime: this.clickStarTime,
              clickEndTime: this.clickEndTime,
              clickDuration: 600,
              clickIp: this.ip,
              IsAutomatic: 1
            },
            headers: {
              authToken: localStorage.getItem("authToken")
            }
          })
          .then(resp => {
            //  console.log(resp)
          })
          .catch(err => {
            // this.$Message.error("数据加载失败：" + err);
          });
      },
      //字典数据
      getdata() {
        var posturl =
          this.config.baseUrl.pro +
          "/DataDictionary/GetDicList?DicCode=indexPage&page=1&limit=100000";
        axios
          .request({
            url: posturl,
            method: "post",
            changeOrigin: true, //允许跨域
            headers: {
              authToken: localStorage.getItem("authToken"),
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              // console.log(resp);
              //这里进行赋值
              this.teid = resp.data.result[0].id;
            }
          })
          .catch((err) => {
            // console.log(err);
            // this.$Message.info("删除失败");
          });
      },
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      autoUpdate() { // 用来触发更新函数
        this.ipcRenderer.send('checkForUpdate')
      },
    },
    mounted() {
      this.isUserAgent = this.$config.baseUrl.isUserAgent;
      console.log(navigator.userAgent);
      if (this._isMobile()) {
        // this.pc = false;
      }
      // this.getdata();
      //无限bebug
      // setInterval(() => {
      //   (function (a) { return (function (a) { return (Function("Function(arguments[0]+\"" + a + "\")()")) })(a) })("bugger")("de", 0, 0, (0, 0));
      // }, 1000);
      // router.afterEach((to, from, next) => { document.querySelector("body").setAttribute("style", "overflow: auto !important;")});
      setTimeout(() => {
        //需要定时执行的代码
        if (this.list.length == 1 && this.list[0] == 'home') {
          this.getmetime();
        }
      }, 600000)
    },
    watch: {
      $route(to, from) {
        if (to.name == "Application") {
          this.is_display = false;
        } else {
          this.is_display = true;
        }
        this.ipt = to.name;
        // console.log(to.name);
        var el = false;
        if (this.list == undefined || this.list == null || this.list.length <= 0) {
          // console.log('12222222')
          this.list.push(to.name)
        } else {
          for (let i = 0; i < this.list.length; i++) {
            // console.log(this.list[i])
            if (this.list[i] == to.name) {
              el = false;
              break;
            } else {
              el = true;
            }
          }
        }
        if (el) {
          this.list.push(to.name)
        }
        // console.log(this.list)
      },
    },
  };
</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  body {
    overflow: auto !important;
    padding-right: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue